import { action } from "@ember/object"
import { scheduleOnce } from "@ember/runloop"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type { CardStack } from "@shared/models/card-stack"
import styles from "./add-comment-form.module.css"

interface Args {
  lesson: CardStack
}

export default class AddCommentFormComponent extends Component<Args> {
  readonly styles = styles

  @tracked commentText

  @action updateComment(text) {
    this.commentText = text
  }

  focusOnInput(element) {
    scheduleOnce("afterRender", this, () => {
      element.focus()
    })
  }
}
